import React, { useState, useRef } from 'react'
import Select from 'react-select'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import FormCheck from 'react-bootstrap/FormCheck'
import Container from 'react-bootstrap/Container'
import '../css/annotation-properties.css'
import '../css/modal.css'
import { CopyAnnotation, DeleteAnnotations } from '../Api/AnnotationApi'
import { ToastError, ToastLoading, ToastSuccess } from './ToastDisplay'
import { BeaconSetSuggestions } from './BeaconDialogMap'
import { Logger } from 'aws-amplify';
const logger = new Logger('CopyAnnotations');


function AnSetsToOptions(model) {
    return model?.AnnotationSets?.map(a => ({ value: a.AnnotationSetId, label: a.Title }));
}

//add a model if it has a CRS in common with source model
function CompatibleModelsToOptions(project, sourceModel) {
    let options = [];

    if (sourceModel) {

        project?.Models?.forEach(destModel => {

            //go through prospective dest model's crss
            for (let destModelCrsIndex = 0; destModelCrsIndex < destModel?.CRSs?.length; destModelCrsIndex++) {
                const destModelCrs = destModel.CRSs[destModelCrsIndex];

                if (sourceModel?.CRSs?.find(sourceCrs => sourceCrs.CrsId === destModelCrs.CrsId)) {
                    options.push({ value: destModel, label: destModel.Title });
                    break;
                }

            }


        });
    }
    return options;

}

export function CopyAnnotationsAround(props) {
    const { project, currentModel, currentAnnotationSet, show, setShow, helpContext, parentHelpContext, selectedAnnotationIds, deselectAnnotation } = props;

    logger.debug("props", props);

    const form = useRef(null);

    const [validated, setValidated] = useState(false);
    const [availableDestModelOptions, setAvailableDestModelOptions] = useState();
    const [availableDestinationAnSetOptions, setAvailableDestinationAnSetOptions] = useState();
    const [selectedDestModelOption, setSelectedDestModelOption] = useState();
    const [selectedDestinationAnSetOption, setSelectedDestinationAnSetOption] = useState({ value: currentAnnotationSet?.AnnotationSetId, label: currentAnnotationSet?.Title });
    const [destModelValid, setDestModelValid] = useState();
    const [destinationAnSetValid, setDestinationAnSetValid] = useState();
    const [annotationCopyProgress, setAnnotationCopyProgress] = useState(0);
    const [isMove, setIsMove] = useState(true);

    const [annotationsToCopy, setAnnotationsToCopy] = useState([]);

    const [uiDisabled, setUiDisabled] = useState(false);
    const toastId = useRef();

    React.useEffect(() => {
        if (show) {
            BeaconSetSuggestions(helpContext);
        }
        else {
            BeaconSetSuggestions(parentHelpContext);
        }
    }, [helpContext, parentHelpContext, show])

    React.useEffect(() => {

        if (show) {
            setAnnotationsToCopy([]);

            setAvailableDestModelOptions(project ? CompatibleModelsToOptions(project, currentModel) : null);
            setSelectedDestModelOption(currentModel ? { value: currentModel, label: currentModel?.Title } : null);

            setAvailableDestinationAnSetOptions(currentModel ? AnSetsToOptions(currentModel) : null);
            setSelectedDestinationAnSetOption(null);
        }
        else {
            setAnnotationCopyProgress(0);
            setAnnotationsToCopy([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show])

    //model has changed, update available destination an sets
    React.useEffect(() => {

        if (selectedDestModelOption) {
            setAvailableDestinationAnSetOptions(AnSetsToOptions(selectedDestModelOption?.value));
        }

    }, [selectedDestModelOption])

    React.useEffect(() => {
        //copy an annotation, from the end of the list to the beginning
        if (annotationsToCopy.length > 0) {
            let newAnnotationsToCopy = JSON.parse(JSON.stringify(annotationsToCopy))

            CopyAnnotation(currentAnnotationSet.AnnotationSetId, selectedDestinationAnSetOption.value, newAnnotationsToCopy[0])
                .then(res => {
                    deselectAnnotation(newAnnotationsToCopy[0]); //deselect the annotation that was copied

                    DeleteAnnotations({ AnnotationIds: [newAnnotationsToCopy[0]] })
                        .then(() => {

                            //finished?
                            if (newAnnotationsToCopy.length === 1) {
                                ToastSuccess("Annotations " + (isMove ? "moved" : "copied") , toastId.current, 2000);
                                setAnnotationsToCopy([]);
                                setUiDisabled(false);
                                setShow(false);
                            }
                            else {
                                newAnnotationsToCopy.splice(0, 1); //remove copied/moved item
                                setAnnotationCopyProgress(newAnnotationsToCopy.length - 1);
                                setAnnotationsToCopy(newAnnotationsToCopy);
                            }
                        });
                })
                .catch(err => {
                    logger.debug("CopyAnnotations fail err", err);
                    ToastError(err.message, err.cause, toastId.current);
                    setUiDisabled(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [annotationsToCopy])

    function onSave(event) {
        event.preventDefault();

        setDestModelValid(selectedDestModelOption ? true : false);
        setDestinationAnSetValid(selectedDestinationAnSetOption ? true : false);

        if (form.current.checkValidity() && selectedDestModelOption && selectedDestinationAnSetOption) {

            setUiDisabled(true);
            toastId.current = ToastLoading(isMove ? "Moving Annotations" : "Copying Annotations");

            //kick off copy
            setAnnotationsToCopy(JSON.parse(JSON.stringify(selectedAnnotationIds)));
        }
        else {
            //failed validation
            event.stopPropagation();

        }

        setValidated(true);
    }

    function onClose() {
        props.setShow(false);
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            keyboard={true}
            centered
            dialogClassName="modal-700w"
        >
            <Modal.Header closeButton>
                <Modal.Title>{ (isMove ? "Move" : "Copy") + " Annotations"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className="mx-2 my-2">
                    <Row>
                        <Form ref={form} noValidate validated={validated} onSubmit={onSave}>
                            <Form.Group className="my-2" controlId="formModelTitle" as={Row}>
                                <Form.Label column sm={12}>{"Note: Models must be connected by a CRS Transform path to allow " + (isMove ? "mov" : "copy") + "ing."}</Form.Label>
                            </Form.Group>
                            <Form.Group controlId="formPositiveOnly" as={Row}>
                                <Form.Label column sm={3} >Move</Form.Label>
                                <Col sm={8}>
                                    <FormCheck
                                        className="mt-2"
                                        type="switch"
                                        id="suppressEmail"
                                        label=""
                                        checked={isMove}

                                        onChange={(e) => setIsMove(!isMove)} />
                                </Col>
                            </Form.Group>

                            <Form.Group controlId="formGroupDest" as={Row}>
                                <Form.Label column sm={4}>Destination Model:</Form.Label>
                                <Col sm={6}>
                                    <Select
                                        value={selectedDestModelOption}
                                        onChange={setSelectedDestModelOption}
                                        closeMenuOnSelect={true}
                                        name="models"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select Destination Model..."
                                        options={availableDestModelOptions} />
                                    {(!destModelValid && validated) &&
                                        <Form.Text className="text-danger">
                                            {"Please select a model to" + (isMove ? "move" : "copy") + " to."}
                                        </Form.Text>
                                    }
                                </Col>
                            </Form.Group>
                            <Form.Group controlId="formGroupAnSetSource" as={Row}>
                                <Form.Label column sm={4}>Destination Annotation Set:</Form.Label>
                                <Col sm={6}>
                                    <Select
                                        value={selectedDestinationAnSetOption}
                                        onChange={setSelectedDestinationAnSetOption}
                                        closeMenuOnSelect={true}
                                        name="models"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select Destination Annotation Set..."
                                        options={availableDestinationAnSetOptions} />
                                    {(!destinationAnSetValid && validated) &&
                                        <Form.Text className="text-danger">
                                            Please select a Destination Annotation Set.
                                        </Form.Text>
                                    }
                                </Col>
                            </Form.Group>

                            {(annotationCopyProgress > 0) &&
                                <Form.Group className="my-2" controlId="formModelTitle" as={Row}>
                                    <Form.Label column sm={4}>Annotations to copy:</Form.Label>
                                    <Col sm={6} className="my-2">
                                        {annotationCopyProgress}
                                    </Col>
                                </Form.Group>
                            }
                        </Form>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={uiDisabled} variant="primary" onClick={onSave}>{(isMove ? "Move" : "Copy")}</Button>
                <Button disabled={uiDisabled} variant="secondary" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>

    );

}

export default CopyAnnotationsAround;